import { featureFlagFlags } from '@/plugins/rollout';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';

const gateway = isProdVersion()
  ? featureFlagFlags.gatewayProd.getValue()
  : featureFlagFlags.gatewayStaging.getValue();

export default gateway;
